<template>
  <div class="Tooltip" v-bind:style="locationStyle" v-if="asset && asset.name">
    <table>
      <tr>
        <td colspan="2" class="Tooltip__Header">
          <ExchangeIcon
            v-if="asset.exchId > 0"
            :exchId="asset.exchId"
            :size="14"
            class="mr-1"
          />
          {{ asset.name }}
          <em>({{ asset.currency || asset.symbol }})</em>
        </td>
      </tr>
      <tr>
        <td>{{ $t("global.price") }}</td>
        <td>{{ formatMoney(asset.price) }}</td>
      </tr>
      <tr v-if="!incognitoMode">
        <td>{{ $t("global.holdings") }}</td>
        <td>{{ formatNumber(asset.holdings || asset.holdingsLeft) }}</td>
      </tr>
      <tr v-if="!profitlossMode && !incognitoMode">
        <td>{{ $t("global.valuation") }}</td>
        <td>{{ formatMoney(asset.price * asset.holdings) }}</td>
      </tr>
      <tr v-if="profitlossMode && !incognitoMode">
        <td>{{ profitlossShowHistory ? "Profit/Loss" : $t("global.valuation") }}</td>
        <td>{{ formatMoney(asset.valuation) }}</td>
      </tr>
      <tr>
        <td>{{ $t("global.share") }}</td>
        <td>{{ formatNumber(asset.share) }}%</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NumbersMixin from "@/mixins/numbers";
import ExchangeIcon from "@/components/ExchangeIcon";

export default {
  name: "Tooltip",
  mixins: [NumbersMixin],
  components: {
    ExchangeIcon,
  },
  props: {
    asset: {
      type: Object,
      required: false,
    },
    top: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
  },
  computed: {
    locationStyle() {
      if (!this.top && !this.left) {
        return {};
      }
      return {
        top: `${this.top}px`,
        left: `${this.left}px`,
      };
    },
    ...mapGetters({
      incognitoMode: "settings/incognitoMode",
      profitlossMode: "settings/profitlossMode",
      profitlossShowHistory: "profitloss/showHistory",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/mixins";
@import "~@/scss/variables";

.Tooltip {
  display: block;
  position: absolute;
  z-index: 1;
  background: rgba(#000, 0.8);
  color: #fff;
  transition: all 0.2s ease;
  pointer-events: none;
  white-space: nowrap;
  top: 30%;
  left: 30%;

  font-size: 15px;
  padding: 12px 20px;
  border-radius: 15px;

  @include breakpoint-manual(max-width, $break-extra-large - 1px) {
    transform: translate(-50%, 0%);
  }

  .Tooltip__Header {
    font-weight: bold !important;
    font-size: 16px;
  }

  em {
    font-style: normal;
    opacity: 0.8;
    font-weight: 300;
  }

  td:first-child {
    padding-right: 8px;
    width: 80px;
    font-weight: bold;
  }

  td:last-child {
    /*font-weight: 300;*/
  }
}
</style>
